import React from "react";
import useUserStore from "../../../storeModules/useUserStore";
import useBotControlStore from "../../../storeModules/useBotControlStore";
import useConversacaoStore from "../../../storeModules/useConversacaoStore";
import findStep from "./findStep";
import { resetStoreComprarNovaCota } from "../../../storeModules/resetStoreComprarNovaCota";
import useInitialConfigStore from "../../../storeModules/useInitialConfigStore";
import { clearResumeExtraStorage } from "../../../utils/resumeStorage";
import { sanitizeUrl } from "../../../utils/sanitize";
import {
  tagSemMetodoPagamento,
  tagBtnWhatsapp,
  tagRendaExtra,
} from "../../../utils/sendTag";
import { getRemoteValueEnv } from "../../../setup";
import BotButton from "../../../components/bot-button";
import IconsWhatsapp from "../../../assets/icons/ico-whatsapp.png";
import { rendaExtraOptions } from "../../../utils/constants";
import TimerButton from "../../../components/TimerButton";
import trackConversacaoStep from "../../../utils/trackConversacaoStep";

const getAntiFraudeTextButton = () => {
  const { anti_fraude } = JSON.parse(
    getRemoteValueEnv("general_copys_dev", "general_copys_prod").asString()
  );
  return anti_fraude.button ? anti_fraude.button : "FALAR COM UM ESPECIALISTA";
};

const clearResumeStorage = () => {
  localStorage.removeItem("mycon_lead_id");
  localStorage.removeItem("mycon_conversacao_id");
  localStorage.removeItem("mycon_selected_plano");
  localStorage.removeItem("mycon_fetched_proposta");
  localStorage.removeItem("mycon_fetched_plan_details");
  localStorage.removeItem("mycon_payment_boleto");
  localStorage.removeItem("mycon_payment_pix");
  clearResumeExtraStorage();
};

const startNewSimulationFromZero = async () => {
  clearResumeStorage();
  resetStoreComprarNovaCota();
  useConversacaoStore.getState().setConversacao({
    id: "",
    stage: "",
    metadata: {},
    historico: [],
  });
  useBotControlStore.getState().clearPendingMessageBlock();
  useBotControlStore.setState({
    currentStep: findStep("copy_inicial").index,
  });
};

const openWhatsAppChat = () => {
  window.open(
    "https://api.whatsapp.com/send?1=pt_BR&phone=551131926065",
    "_blank",
    "noopener"
  );

  tagBtnWhatsapp("sem_metodo_pagamento");
};

const errorSteps = [
  {
    name: "erro_sem_planos",
    isWaitingForFetch: true,
    sender: "bot",
    text: () => {
      const userBasicName = useUserStore.getState().basic.nome;
      return `<b>${userBasicName}, não encontrei nenhum plano com este valor.</b> Por favor, faça uma nova simulação.`;
    },
    options: [
      {
        text: "SIMULAR NOVAMENTE",
        action: () => {
          useBotControlStore.setState({
            currentStep: findStep("pergunta_valor_credito").index,
          });
        },
      },
      {
        text: "FALAR COM UM ESPECIALISTA",
        action: () => {
          const linkWhatsApp = useInitialConfigStore.getState().linkWhatsApp;
          window.open(sanitizeUrl(linkWhatsApp), "_blank");
        },
      },
    ],
  },
  {
    name: "erro_renda_insuficiente",
    isWaitingForFetch: true,
    sender: "bot",
    text: () => "Você tem alguma renda extra ou familiar?",
    options: [
      {
        text: "NÃO TENHO",
        action: () => {
          useBotControlStore.setState({
            currentStep: findStep("sem_renda_extra").index,
          });
        },
      },
      {
        text: "TENHO",
        action: () => {
          useBotControlStore.setState({
            currentStep: findStep("pergunta_renda_extra").index,
          });
        },
      },
      {
        text: "FALAR COM OS ESPECIALISTAS",
        action: () => {
          const linkWhatsApp = useInitialConfigStore.getState().linkWhatsApp;
          window.open(sanitizeUrl(linkWhatsApp), "_blank");

          tagRendaExtra(rendaExtraOptions.FALAR_COM_ESPECIALISTA);
        },
      },
    ],
  },
  {
    name: "erro_proposta",
    isWaitingForFetch: true,
    sender: "bot",
    text: "Desculpe, estamos passando por instabilidades. Tente novamente mais tarde.",
    options: [
      {
        text: "FAZER NOVA SIMULAÇÃO",
        action: () => {
          startNewSimulationFromZero();
        },
      },
      {
        text: "TENTAR NOVAMENTE",
        action: () => {
          resetStoreComprarNovaCota();

          useBotControlStore.setState({
            currentStep: findStep("copy_intermediaria_2").index,
          });
        },
      },
      {
        text: "FALAR COM OS ESPECIALISTAS",
        action: () => {
          const linkWhatsApp = useInitialConfigStore.getState().linkWhatsApp;
          window.open(sanitizeUrl(linkWhatsApp), "_blank");
        },
      },
    ],
  },
  {
    name: "erro_geral",
    isWaitingForFetch: true,
    sender: "bot",
    text: "Desculpe, estamos passando por instabilidades. Tente novamente mais tarde.",
    options: [
      {
        text: "TENTAR NOVAMENTE",
        action: () => {
          resetStoreComprarNovaCota();

          useBotControlStore.setState({
            currentStep: findStep("copy_intermediaria_2").index,
          });
        },
      },
      {
        text: "FALAR COM OS ESPECIALISTAS",
        action: () => {
          const linkWhatsApp = useInitialConfigStore.getState().linkWhatsApp;
          window.open(sanitizeUrl(linkWhatsApp), "_blank");
        },
      },
    ],
  },
  {
    name: "sem_metodos_pagamento",
    sender: "bot",
    text: () => {
      const { anti_fraude } = JSON.parse(
        getRemoteValueEnv("general_copys_dev", "general_copys_prod").asString()
      );

      return anti_fraude.bubble
        ? anti_fraude.bubble
        : "Para seguir com a escolha da forma de pagamento da primeira parcela e efetivar a contratação da sua cota, clique no botão abaixo para confirmar o seu cadastro com um de nossos especialistas.";
    },
    action: () => {
      tagSemMetodoPagamento();
    },
    stepButtons: [
      <BotButton
        size="small"
        variant="whatsapp"
        startIcon={
          <img
            alt="Atendimento via Whatsapp"
            className="Media"
            src={IconsWhatsapp}
          />
        }
        text={() => {
          return getAntiFraudeTextButton();
        }}
        enabled={true}
        onClick={() => {
          trackConversacaoStep({
            stepName: "sem_metodos_pagamento",
            userMessage: getAntiFraudeTextButton(),
            userOnly: true,
          });
          return openWhatsAppChat();
        }}
      />,
    ],
  },
  {
    name: "erro_conexao_inicio",
    isWaitingForFetch: true,
    sender: "bot",
    text: "Oops...",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("erro_conexao").index,
      });
    },
  },
  {
    name: "erro_conexao",
    isWaitingForFetch: false,
    sender: "bot",
    text: "Parece que sua conexão está com problemas. <br> Verifique sua conexão com a internet e tente novamente.",
    stepButtons: [
      <TimerButton
        text="AGUARDE:"
        waitTime={10}
        onClick={() => {
          trackConversacaoStep({
            stepName: "erro_conexao",
            userMessage: "TENTAR NOVAMENTE",
            userOnly: true,
          });
          const { stepToBack } = useBotControlStore.getState();
          useBotControlStore.setState({
            currentStep: stepToBack,
          });
        }}
      />,
    ],
  },
];

export default errorSteps;
